module.exports = __webpack_public_path__ + "img/Step05b2.e22179b5.webp";